export default __webpack_public_path__ + "static/media/documentation.bd622e78.svg";